export default __webpack_public_path__ + "static/media/e-bunifikasi-picturemark-l.ff499a2c.svg";